import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { ButtonScreenPoint, KeyboardModel, MapOxxoTopicFour, MonitorIntroTopicFour } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { PinPad } from "../objects/Topics/TopicTwo/PinPad";
import { Tarjeta } from "../objects/Topics/TopicTwo/Tarjeta";

export class SceneTopicFour extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicFour(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.monitor = new MonitorIntroTopicFour(this.loadingManager);
		this.monitor.visible = false
		this.add(this.monitor);

		this.buttonPointerScreen = new ButtonScreenPoint(this.loadingManager)
		this.buttonPointerScreen.visible = false
		this.buttonPointerScreen.rotation.y = -1.5343
		this.add(this.buttonPointerScreen)

		this.keyboard = new KeyboardModel(this.loadingManager)
		this.keyboard.visible = false
		this.add(this.keyboard)

		this.pinPad = new PinPad(this.loadingManager);
		this.pinPad.visible = false
		this.add(this.pinPad)

		this.tarjeta = new Tarjeta(this.loadingManager);
		// this.tarjeta.visible = false
		this.add(this.tarjeta)
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}


	resetActOne() {
		this.characterSelected.visible = false
	}

	sceneActivityOneState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic4.actScene, (step = "") => {
			switch (step) {
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					});
					this.characterSelected.visible = true
					break;
				case "expand_desk":
					this.camera.moveCameraToPoint(new Vector3(-13.6326, 0.3982, -1.9179), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = false
					});
					break;
				case "monitor_1":
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
						this.characterSelected.visible = false
					});
					this.monitor.visible = true
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_01)
					this.buttonPointerScreen.visible = true
					this.buttonPointerScreen.position.set(-11.566, 0.22, 2.47)
					break;
				case "monitor_2":
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_02)
					this.buttonPointerScreen.position.set(-11.566, -0.05, 2.73)
					break;
				case "monitor_3":
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_03)
					this.buttonPointerScreen.position.set(-11.566, 0.12, 2.8)
					break;
				case "monitor_4":
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
						this.characterSelected.visible = false
					});
					this.monitor.visible = true
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_04)
					this.buttonPointerScreen.position.set(-11.566, -0.23, 2.7)
					break;
				case "monitor_5":
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_05)
					this.buttonPointerScreen.position.set(-11.566, 0.08, 3.07)
					break;
				case "monitor_6":
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_06)
					this.buttonPointerScreen.position.set(-11.566, 0.18, 2.38)
					break;
				case "monitor_7":
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_07)
					break;
				case "monitor_8":
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
						this.characterSelected.visible = false
					});
					this.monitor.visible = true
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_08)
					this.buttonPointerScreen.position.set(-11.566, -0.22, 2.98)
					break;
				case "monitor_9":
					this.monitor.selectTexture(this.monitor.namesTextures.topic4_09)
					this.buttonPointerScreen.position.set(-11.566, -0.03, 2.65)
					break;
				case "button_position":
					this.buttonPointerScreen.position.set(-11.566, -0.23, 3.21)
					break;
				case "button_visible":
					this.buttonPointerScreen.visible = true
					break;
				case "button_hidden":
					this.buttonPointerScreen.visible = false
					break;
				case "move_keyboard_1":
					this.camera.moveCameraToPoint(new Vector3(-11.5649, -0.3277, -0.7974), 1, new Vector3(-11.205, -1.261, -0.797), () => {
						this.camera.control.minDistance = 0.8;
						this.camera.control.maxDistance = 1.05;
					});
					this.keyboard.position.set(-11.3, -0.99, -0.8)
					this.keyboard.rotation.set(0, -1.57, 0)
					this.keyboard.visible = true
					this.keyboard.onAnimate(this.keyboard.Enter)
					break;
				case "move_keyboard_2":
					this.keyboard.clearKeyAnimation(this.keyboard.Enter)
					this.keyboard.onAnimate(this.keyboard.Subtotal)
					break;
				case "move_desk_final":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					});
					this.characterSelected.visible = true
					this.keyboard.clearKeyAnimation(this.keyboard.Subtotal)
					this.monitor.visible = false
					this.keyboard.visible = false
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic4.actScene, (step = "") => {
			switch (step) {
				case "view_animation":
					this.characterSelected.visible = false
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1.5;
					this.camera.control.maxDistance = 1.9;
					this.camera.moveCameraToPoint(new Vector3(-10.504, -0.3049, 0.3529), 1, new Vector3(-10.795, -1.776, -0.363), () => {
						this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
						this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					});

					this.pinPad.visible = true
					this.pinPad.position.set(-10.85, -0.97, 0.078)
					this.tarjeta.insertCard()
					this.keyboard.position.set(-11.3, -0.99, -0.8)
					this.keyboard.rotation.set(0, -1.57, 0)
					this.keyboard.visible = true
					// Wait for the animations
					setTimeout(() => {
						ObserverEmitter.emit(EVENTS.tema6.topic4.listenScene, "move_desktop")
						this.keyboard.onAnimate(this.keyboard.T)
						this.camera.moveCameraToPoint(new Vector3(-11.5649, -0.3277, -0.7974), 1, new Vector3(-11.205, -1.261, -0.797), () => {
							this.camera.control.minDistance = 0.8;
							this.camera.control.maxDistance = 1.05;
						});
					}, 3000);
					break;
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					});
					this.pinPad.visible = false
					this.tarjeta.removeCard()
					this.keyboard.visible = false
					this.keyboard.clearKeyAnimation(this.keyboard.T)
					break;
				case "move_client_1":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {

					});
					break;
				case "move_client_2":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {

					});
					this.pinPad.visible = false
					this.tarjeta.removeCard()
					this.keyboard.visible = false
					this.keyboard.clearKeyAnimation(this.keyboard.T)
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}
	sceneActivityThreeState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic4.actScene, (step = "") => {
			switch (step) {
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					});
					break;
				case "move_client":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {

					});
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true
					this.activeAudio()

					this.sceneActivityTwoState();
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityThreeState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// const name = interactions[0].object.name;
				// ObserverEmitter.emit(EVENTS.tema3.listenClick, name);
			}
		});
	}

	renderAnimations(delta) {
	}
}
